<template>
	<div class="pBox" v-if="list.length > 0" v-loading="loading" style="width: 100%;height: 100%;display: flex;align-items: center;">
		<div class="box" v-if="equipment == 'pc' && navEquipment == 'pc'" style="width: 100%;height: 100%;display: flex;align-items: center;">
			<div v-for="(item,index) in list" :key="index">
				<div>
					<el-popover :disabled="!item.children_group || item.children_group.length == 0" trigger="hover" placement="bottom">
						<!--  <el-table :data="gridData">
					    <el-table-column width="150" property="date" label="日期"></el-table-column>
					    <el-table-column width="100" property="name" label="姓名"></el-table-column>
					    <el-table-column width="300" property="address" label="地址"></el-table-column>
					  </el-table> -->
						<div  :style="{width:item.isFull?'98vw':'none',left:item.isFull?'0px':'none'}" class="more_item">
							<div :style="{width:item.isFull?'70%':'none'}" style="display: flex;">
								<div style="margin: 10px;min-width: 250px;"
									v-for="(childrenGroupItem,childrenGroupIndex) in item.children_group"
									:key="childrenGroupIndex">
									<div style="font-weight: bold;font-size: 15px;">{{childrenGroupItem.name}}</div>
									<div style="margin-top: 30px;" v-if="childrenGroupItem.type == 'image'">
										<a @click="headNavTo({
					  					...childrenGroupItem.image,
					  					new_window:true
					  				})" target="_self" href="javascript:void(0)">
											<img style="width: 205px;height: 205px;"
												:src="childrenGroupItem.image.image" />
										</a>
									</div>
									<div style="margin-top: 36px;font-size: 12px;color: #7f7f7f ;"
										v-if="childrenGroupItem.type == 'link'">
										<div :style="{'--hover': compontentStyle.hoverColor}" class="linktit"
											style="margin-top: 30px;" @click="navTo(childrenItem)"
											v-for="(childrenItem,childrenIndex) in childrenGroupItem.children"
											:key="childrenIndex">
											<div>
												{{childrenItem.link.text}}
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<!-- <el-button >click 激活</el-button> -->
						<div slot="reference" @mouseleave.stop.prevent="mouseleaveMore('t')"
							@mouseenter="mouseenterMore(index,item)" style="position: relative;"
							:style="{'--hover': compontentStyle.hoverColor}" @click="headNavTo(item)" class="nav_item">
							<div style="">
								{{item.name}}
							</div>
							<i v-if="item.children_group" style="margin-left: 5px;" class="el-icon-caret-bottom"></i>
							<div v-if="item.badge.name"
								style="position: absolute;top: -24px;width: 100%;display: flex;justify-content: center;min-width: 80px;">
								<div class="qipao"
									:style="{backgroundColor:item.badge.bg_color,color:item.badge.text_color}">
									{{item.badge.name}}
								</div>
							</div>
						</div>
					</el-popover>
				</div>
			</div>
		</div>
		<div style="width: 100%;height: 100%;display: flex;align-items: center;" v-if="equipment == 'phone' || navEquipment == 'phone'">
			<img @click="show = true" style="width: 40px;height: 40px;" src="../img/nav.png" />
		</div>
		<van-popup lazy-render style="height: 100%;width: 80%" position="left" v-model="show">
			<div
				style="border-bottom: solid 1px #d4d4d4;font-size: 18px;height: 56px;display: flex;justify-content: space-between;align-items: center;">
				<div style="margin-left: 20px;">菜单</div>
				<i @click="show = false" style="margin-right: 20px;font-weight: none;font-size: 18px;"
					class="el-icon-s-fold"></i>
			</div>
			<el-menu class="el-menu-vertical-demo" @open="handleOpen" @close="handleClose">
				<div v-for="(item,index) in list" :key="index">
					<el-submenu :unique-opened="false" style="border-bottom:solid 1px #e1e1e1;"
						v-if="item.children_group" :index="index + ''">
						<template slot="title">
							<div @click.stop.prevent="headNavTo(item)"
								style="display: flex;width: 87%;align-items: center;border-right: solid 1px #e1e1e1;">
								<div><span slot="title">{{item.name}}</span></div>
								<div v-if="item.badge.name"
									style="display: flex;align-items: center;margin-left: 10px;">
									<div :style="{'--bg':item.badge.bg_color}" class="qbt"></div>
									<div :style="{backgroundColor:item.badge.bg_color,color:item.badge.text_color}"
										style="height: 24px;display: flex;align-items: center;padding: 0px 6px;font-size: 12px;">
										{{item.badge.name}}
									</div>
								</div>
							</div>
						</template>
						<el-submenu :unique-opened="false" style="border-bottom:solid 1px #e1e1e1;"
							:key="childrenGroupIndex" :index="childrenGroupIndex + '-' + index"
							v-for="(childrenGroupItem,childrenGroupIndex) in item.children_group">
							<template slot="title">
								<div
									style="display: flex;justify-content: space-between;width:85%;align-items: center;border-right: solid 1px #e1e1e1;font-weight: bold;">
									<span slot="title">{{childrenGroupItem.name}}</span>
								</div>
							</template>
							<el-menu-item style="border-bottom:solid 1px #e1e1e1;"
								:style="{height:childrenGroupItem.type == 'image'?'200px':'none'}"
								v-for="(childrenItem,childrenIndex) in childrenGroupItem.children" :key="childrenIndex"
								:index="childrenGroupIndex + '-'+ childrenIndex + '-' + index">
								<div @click.stop.prevent="navTo(childrenItem)" v-if="childrenGroupItem.type == 'link'"
									style="display: flex;justify-content: space-between;width: 100%;align-items: center;">
									<span slot="title">{{childrenItem.link.text}}</span>
								</div>
								<div style="width: 100%;align-items: center;" v-if="childrenGroupItem.type == 'image'">
									<a @click="headNavTo({
										...childrenGroupItem.image,
										new_window:true
									})" target="_self" href="javascript:void(0)">
										<img style="width: 180px;height: 180px;margin-top: 10px;"
											:src="childrenGroupItem.image.image" />
									</a>
								</div>
							</el-menu-item>
						</el-submenu>
					</el-submenu>
					<el-menu-item style="border-bottom:solid 1px #e1e1e1;" @click="headNavTo(item)"
						v-if="!item.children_group" :index="index + ''">
						<div style="display: flex;width: 90%;align-items: center;">
							<span slot="title">{{item.name}}</span>

							<div v-if="item.badge.name" style="display: flex;align-items: center;margin-left: 10px;">
								<div :style="{'--bg':item.badge.bg_color}" class="qbt"></div>
								<div :style="{backgroundColor:item.badge.bg_color,color:item.badge.text_color}"
									style="height: 24px;display: flex;align-items: center;padding: 0px 6px;font-size: 12px;">
									{{item.badge.name}}
								</div>
							</div>
						</div>
					</el-menu-item>
				</div>
			</el-menu>
		</van-popup>
	</div>
</template>

<script>
	import {
		getDesignMenu
	} from '../../api/nav.js'
	export default {
		props: {
			systemConfig: {
				type: Object,
				default: () => {
					return {}
				}
			},
			selectdItem: {
				type: Object,
				default: () => {
					return {}
				}
			},
			type: {
				type: String,
				default: "design"
			},
			equipment: {
				type: String,
				default: "pc"
			},
			compontentStyle: {
				type: Object,
				default: () => {
					return {}
				}
			}
		},
		data() {
			return {
				pClientWidth:-1,
				scrollWidth:-1,
				navEquipment:"pc",
				// type: '',
				show: false,
				loading: false,
				activeIndex: -1,
				list: []
			}
		},
		async mounted() {
			console.log('this.type', this.type)
			// 使用方法
			if (this.type != 'build') {
				this.loading = true
				let wsid = this.$cookies.get("wsid")
				let data = await getDesignMenu({
					wsid
				})
				this.list = data.data.data
				this.loading = false
				console.log('compontentStyle', this.compontentStyle)
				console.log('getDesignMenu data', this.list)
			} else {
				this.list = this.selectdItem.compontChildren[0].data.list
			}
			if(this.type != 'design'){
				this.$nextTick(()=>{
					window.addEventListener('resize', this.changeFontSize);
					this.changeFontSize()
				})
			}
		},
		methods: {
			changeFontSize() {
				const element = document.querySelector('.box');
				const pElement = document.querySelector('.pBox');
				console.log('pElement',pElement)
				if(element) {
					if (this.isOverflowing(element)) {
					  console.log('元素溢出');
					  this.pClientWidth = pElement.clientWidth
					  this.scrollWidth = element.scrollWidth
					  this.navEquipment = 'phone'
					} else {
					  console.log('元素没有溢出');
					   this.navEquipment = 'pc'
					}
				}
				if(this.pClientWidth != -1) {
					if(pElement.clientWidth  >  this.scrollWidth ) {
						 this.navEquipment = 'pc'
					}
				}
			},
			
			
			isOverflowing(element) {
			  return element.scrollWidth > element.clientWidth;
			},
			
			
			getLanguage(item) {
				console.log('item', item)
				let str = ''
				item.descriptions.forEach(item => {
					if (item.locale == this.systemConfig.locale) {
						str = item.name
					}
				})
				return str
			},
			handleClose() {

			},
			handleOpen() {

			},
			getPathFromUrl(url) {
				const match = url.match(/^https?:\/\/[^/]+(\/[^?#]*)/);
				return match ? match[1] : '/';
			},

			headNavTo(e) {
				if (!e) {
					return
				}
				console.log(e)
				console.log(window.location.host)
				const path = this.getPathFromUrl(e.link);
				if (this.type != 'build') {
					let arr = e.link.split(window.location.host)
					if(this.$route.path == arr[1]){
					}
					if(this.$route.path == '/') {
						this.$router.push({
							path: arr[1],
						})
						this.show = false
						window.location.reload()
					}else {
						this.show = false
						this.$router.replace({
							path:  arr[1],
							query:{
								nav:new Date().getTime()
							}
						})
					}
					// window.location.reload()
				} else {
					let arr = e.link.split(window.location.host)
					if(this.$route.path == arr[1]){
					}
					if(this.$route.path == '/') {
						this.$router.push({
							path: arr[1],
						})
						this.show = false
						window.location.reload()
					}else {
						this.show = false
						this.$router.replace({
							path: arr[1],
							query:{
								nav:new Date().getTime()
							}
						})
					}
					// window.location.reload()
				}

				// if (e.new_window) {
				// 	window.open(e.link, '_blank')
				// } else {
				// 	window.open(e.link, '_self')
				// }
			},
			navTo(e) {
				console.log('e',e)
				if (!e) {
					return
				}
				const path = this.getPathFromUrl(e.link.link);
				if (this.type != 'build') {
					let arr = e.link.link.split(window.location.host)
					if(this.$route.path == arr[1]){
					}
					if(this.$route.path == '/') {
						this.$router.push({
							path: arr[1],
						})
						this.show = false
						window.location.reload()
					}else {
						this.show = false
						this.$router.replace({
							path:  arr[1],
							query:{
								nav:new Date().getTime()
							}
						})
					}
				} else {
					let arr = e.link.link.split(window.location.host)
					if(this.$route.path == arr[1]){
					}
					if(this.$route.path == '/') {
						this.$router.push({
							path: arr[1],
						})
						this.show = false
						window.location.reload()
					}else {
						this.show = false
						this.$router.replace({
							path:  arr[1],
							query:{
								nav:new Date().getTime()
							}
						})
					}
				}


				// if (e.link.new_window) {
				// 	window.open(e.link.link, '_blank')
				// } else {
				// 	window.open(e.link.link, '_self')
				// }
			},
			mouseenterMore(index, item) {
				if (item.children_group) {
					this.activeIndex = index
				}

			},
			mouseleaveMore(type) {
				let that = this
				setTimeout(() => {
					that.activeIndex = -1
				}, 100)

			}
		}
	}
</script>

<style scoped>
	.qbt {
		width: 0;
		height: 0;
		border-right: 12px solid var(--bg);
		border-top: 12px solid transparent;
		border-bottom: 12px solid transparent;
	}

	.qipao {
		padding: 0px 4px 4px 4px;
		color: #fff;
		text-align: center;
		/* 箭头靠右边 */
		/* clip-path: polygon(0 0, 88% 0, 88% 35%, 95% 50%, 88% 65%, 88% 100%, 0 100%); */
		/* 箭头靠下边 */
		clip-path: polygon(0 0, 100% 0, 100% 85%, 35% 85%, 30% 100%, 50% 85%, 0% 85%);
		/* 箭头靠左边 */
		/* clip-path: polygon(5% 0, 100% 0, 100% 100%,5% 100%, 5% 65%,0 50%,5% 35%); */
		/* 箭头靠下边 */
		/* clip-path: polygon(0 15%, 25% 15%, 30% 0,35% 15%, 100% 15%,100% 100%,0% 100%); */
		/* clip-path: polygon(0 15%, 25% 15%, 30% 0,35% 15%, 100% 15%,100% 100%,0% 100%); */
		font-size: 14px;
		display: flex;
		justify-content: center;
		align-items: center;
		top: -10px;
		min-width: 36px;

	}

	.linktit:hover {
		cursor: pointer;
		color: var(--hover);
	}

	.fade-enter-active,
	.fade-leave-active {
		transition: opacity .5s;
	}

	.fade-enter,
	.fade-leave-to

	/* .fade-leave-active below version 2.1.8 */
		{
		opacity: 0;
	}

	.nav_item {

		cursor: pointer;
		margin-top: 4px;
		margin-bottom: 4px;
		margin-left: 4px;
		margin-right: 4px;

		display: flex;
	}

	.nav_item:hover {
		color: var(--hover);
	}

	.more_item {
		/* background-color: aqua; */
		display: flex;
		align-items: center;
		/* padding: 20px; */
		/* position: fixed; */
		/* background-color: 'none'; */
		/* box-shadow: 1px 1px 15px #a8a8a8; */
		/* margin-top: 10px; */
		display: flex;
		justify-content: center;
		/* z-index: 100; */
		/* 	top:10px;
		left: 10px; */
	}
</style>